import React from 'react'
import { Image, List, Icon, Container, Header } from 'semantic-ui-react';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import timeAgo from './../../../../../helpers/reactTimeAgo';
import defaultImage from './../../../../../images/logo/logo-128.png'
import PlaceHolderSingleLine from './../../../../drive/PlaceHolder/PlaceHolderSingleLine'
import noEventImage from './../../../../../images/grafix-banner/gfx-no-updates.svg'
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import ImageAvater from '../../../../drive/Components/ImageAvater';

class OrganizationRecentUpdates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: 10,
            loadingState: false,
        };
    }

    componentDidMount() {
        this.refs.iRecentUpdateScroll.addEventListener("scroll", () => {
            if (this.refs.iRecentUpdateScroll.scrollTop + this.refs.iRecentUpdateScroll.clientHeight >= this.refs.iRecentUpdateScroll.scrollHeight) {
                this.loadMoreItems();
            }
        });

    }

    loadMoreItems() {
        let eventStreamLength = this.props.recentUpdates && this.props.recentUpdates.data && this.props.recentUpdates.data.length
        if (this.props.recentUpdates.total !== eventStreamLength) {
            this.setState({ loadingState: true });
            setTimeout(async () => {
                if (this.props.eventPage === "organization") {
                    dispatch.notifications.getRecentUpdates({ limit: 20, role: this.props.selectedOrganisation.role });
                }
                else if (this.props.eventPage === 'Team') {
                    dispatch.notifications.getRecentUpdatesForTeamId({ limit: 20, teamId: this.props.match.params.teamId });
                }
                else if (this.props.eventPage === 'User') {
                    dispatch.notifications.getRecentUpdatesForTeamIdAndUserId({
                        limit: 20,
                        organizationId: this.props.match.params.workspaceId,
                        teamId: this.props.match.params.teamId,
                        userId: this.props.match.params.userId
                    });
                }

                this.setState({ limit: this.state.limit + 5, loadingState: false });
            }, 1000);
        }
    }

    render() {
        let windowHeight = window.innerHeight;
        let noEvents = <Container fluid style={{ padding: "70px 0", }} >
            <Image src={noEventImage} size='small' centered={true} style={{ width: "100px" }} className="display-block" />
            <Header as='h5' icon textAlign='center'>
                <Header.Content className="clr-dark-gray" > No recent updates to display!</Header.Content>
            </Header>
        </Container>

        return (
            <div ref="iRecentUpdateScroll" style={{ maxHeight: windowHeight - 250, overflow: "auto", width: "100%" }}>
                <List divided className="display-block " style={{ padding: "10px 0" }}>
                    {this.props.recentUpdates && this.props.recentUpdates.data && this.props.recentUpdates.data.length
                        ? this.props.recentUpdates.data.map((item, i) => {
                            return <List.Item key={i} className="display-block " style={{ padding: "8px 10px" }}>
                                <List.Content floated='right' className="f_10 clr-gray">
                                    <Icon name="group" className="float-right display-block w_100 text-right" />
                                    <div className="display-block" style={{ margin: "15px 0 0 0" }}>{timeAgo(item.createdAt, "bottom center")}</div>
                                </List.Content>

                                <ImageAvater
                                    user={item.from}
                                    imageStyle="w_32 h_32"
                                    className="w_32 h_32 pad_tb_9" />
                                {/* <Image avatar src={item.from ? item.from.profilePic : defaultImage} className="float-left" style={{ margin: "0 10px 0 0" }} /> */}
                                <List.Content className="display-block" verticalAlign='middle'>
                                    <List.Item >
                                        <EllipsisTooltip
                                            name={item.message}
                                            style={{ width: "calc(100% - 120px)", lineHeight: "14px" }}
                                            line={2}
                                            position="top left"
                                        />
                                    </List.Item>
                                </List.Content>
                            </List.Item>
                        })
                        : ''}
                </List>
                {this.state.loadingState || this.props.loaderRecentUpdates ?
                    <div><PlaceHolderSingleLine repeat={5} /> </div> :
                    this.props.recentUpdates && this.props.recentUpdates.data && this.props.recentUpdates.data.length === 0 ?
                        noEvents : null
                }
            </div>
        )
    }
}

export default withRouter(OrganizationRecentUpdates)
